export default {
  title: '示例（简体）',
  rule: {
    title: '免责声明',
    label: '谨此声明本人参加本活动，并愿意遵守由主办机构所订的条文及规则，以及同意以下所列各点：',
    content: ['本人是自愿参加此活动和愿意承担自身的意外风险及责任，并无权向主办机构对本人往返活动场地途中、活动中发生或引致之自身意外、死亡或任何形式的损失提出索偿或追讨责任。',
      '本人声明本人身体情况良好及有能力参加此活动，及没有执业医生曾提出相反意见。',
      '本人愿意接受主办机构要求及提供的药物检查及治疗。',
      '本人于活动当天（2019年2月17日）已经符合参加组别之最低年龄规定（如参加者未年满18岁，须由其家长或监护人签署同意声明）。',
      '本人明白及同意本人的个人资料将转交予主办机构用作活动安排之用途。',
      '本人证实已事先获得同行参加者及/或紧急联系人的同意，可使用其个人资料于本活动的报名表格作报名及/或紧急联系用途。',
      '本人愿意授权予及同意主办机构及传媒在不需要审查情况及不需要本人另外同意下而可使用本人的个人资料、肖像、姓名及声线作为筹办及推广活动之用，包括本人肖像及姓名有可能被使用于主办机构有关本活动之网页、短片及刊物。',
      '本人提交确认即表示同意及确认所有列明之「参加者须知及条款细则」、「免责声明」及「个人资料收集声明」，以及所有不时于活动指定宣传渠道更新的任何更改。'
    ]
  }
}


// WEBPACK FOOTER //
// ./src/locale/demo/zh-cn.js